export default '/build/c735d495.svg'